<script lang="ts" setup>
const theme = useTheming();
const logoURL = theme.outsideLayoutLogoURL;

const localePath = useLocalePath();
</script>

<template>
  <div class="absolute left-0 top-0 z-10 flex w-full items-center justify-between px-4 py-8 md:px-10">
    <div class="grid place-items-center overflow-hidden">
      <NuxtLink :to="localePath('/')">
        <img
          :src="logoURL"
          width="140"
          height="22"
          aria-label="Pixellot logo"
          alt="Pixellot logo"
        >
      </NuxtLink>
    </div>

    <div class="flex items-center gap-6">
      <UserMenu />
      <slot />
    </div>
  </div>
</template>
